import { render, staticRenderFns } from "./CurrencySelector.vue?vue&type=template&id=3a501c92&scoped=true"
import script from "./CurrencySelector.vue?vue&type=script&lang=js"
export * from "./CurrencySelector.vue?vue&type=script&lang=js"
import style0 from "./CurrencySelector.vue?vue&type=style&index=0&id=3a501c92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a501c92",
  null
  
)

export default component.exports